require('./bootstrap');

import { createApp, h } from 'vue';
import { InertiaProgress } from '@inertiajs/progress';
import {createInertiaApp, Link, Head} from '@inertiajs/inertia-vue3';
import DefaultLayout from '@/Layouts/DefaultLayout';
import BaseLayout from '@/Layouts/_BaseLayout';
import VueScrollTo from 'vue-scrollto'
import VueSocialSharing from 'vue-social-sharing'

InertiaProgress.init({
    color: '#371BF4',
});

createInertiaApp({
    resolve: (name) => {
        let page = require(`./Pages/${name}.vue`).default;
        page.layout = page.layout || [BaseLayout, DefaultLayout];
        return page;
    },
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueScrollTo)
            .use(VueSocialSharing)
            .mixin({ methods: { route } })
            .component("Link", Link)
            .component("Head", Head)
            .mount(el);
    },
});
